export const CURRENT_CHALLENGE_NAME = 'Челендж листопада';
